<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSeller()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Auction Report</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
          <button @click="generateReport" class="btn btn-secondary"><i class="fa fa-print"></i> Generate Report</button>&nbsp;
          <button @click="generateSellerReport" class="btn btn-secondary"><i class="fa fa-print"></i> Seller Report</button>&nbsp;
          <button @click="generateBuyerReport" class="btn btn-secondary"><i class="fa fa-print"></i> Buyer Report</button>
        </div><!-- /.container-fluid -->

      </section>

    <!-- Main content -->
    <section class="content">
    	<br>
    	<div class="col-sm-12">

    			<div class="card card-primary card-outline">
    			<div class="card-body overflow-auto">

    			<table class="table table-striped">
    				<thead>
    					<tr>
      					<th scope="col">Lot Number</th>
      					<th scope="col">Seller Name</th>
      					<th scope="col">Seller Number</th>
      					<th scope="col">Warehouse</th>
      					<th scope="col">Net Weight</th>
      					<th scope="col">Gunny Bags</th>
      					<th scope="col">Auction Date</th>
      					<th scope="col">Status</th>
      					<th scope="col">Price/KG</th>
      					<th scope="col">Buyer</th>
      					<th scope="col">Value</th>
      					<th scope="col">(-)less Discount n%</th>
      					<th scope="col">Gross Amount</th>
      					<th scope="col">Add Pack Cost</th>
      					<th scope="col">Net Amount Include GST</th>
      					<th scope="col">Less Commission</th>
      					<th scope="col">Profile Mapping Fee</th>
      					<th scope="col">Total Include GST</th>
      					<th scope="col">Net Amount to Seller</th>
    					</tr>
  					</thead>
  					<tbody>
  						<tr v-for="lot in lots">
  							<td>{{lot.name}}</td>
  							<td>{{lot.seller}}</td>
  							<td>{{lot.seller_number}}</td>
  							<td>{{lot.warehouse}}</td>
  							<td>{{lot.net_weight}}</td>
  							<td>{{lot.gunny_bags}}</td>
  							<td>{{lot.auction_date}}</td>
  							<td>{{lot.status}}</td>
  							<td>{{lot.price}}</td>
  							<td>{{lot.buyer}}</td>
  							<td>{{lot.value}}</td>
  							<td>{{lot.discount}}</td>
  							<td>{{lot.gross}}</td>
  							<td>{{lot.pack_cost}}</td>
  							<td>{{lot.net_amount_include_gst}}</td>
  							<td>{{lot.commission}}</td>
  							<td>{{lot.profile_mapping}}</td>
  							<td>{{lot.total}}</td>
  							<td>{{lot.to_seller}}</td>
  						</tr>
  						<tr>
  							<th>Total</th>
  							<th></th>
  							<th></th>
  							<th></th>
  							<th>{{total.net_weight}}</th>
  							<th>{{total.gunny_bags}}</th>
  							<th></th>
  							<th></th>
  							<th></th>
  							<th></th>
  							<th>{{total.value}}</th>
  							<th>{{total.discount}}</th>
  							<th>{{total.gross}}</th>
  							<th>{{total.pack_cost}}</th>
  							<th>{{total.net_amount_include_gst}}</th>
  							<th>{{total.commission}}</th>
  							<th>{{total.profile_mapping}}</th>
  							<th>{{total.total}}</th>
  							<th>{{total.to_seller}}</th>
  						</tr>
  					</tbody>
    			</table>
    			<br>

    			</div>

    		</div>
    		</div>

		</section>
    <!-- /.content -->

<br>
      <br>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSeller()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import VueHtml2pdf from 'vue-html2pdf'
		import { saveAs } from 'file-saver';
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {
       	 	VueHtml2pdf
   			},

        created(){
        	this.getLotDetails();
        },

        data(){
        	return {
        		lots: [],
        		total: [],
        		seller: ''
        	}
        },

        methods: {
        	getLotDetails(){
        		axios.post("/api/getAuctioneerAuctionReport", {auction_id: this.$route.params.id})
        		.then(response => {
        			this.lots = response.data.data;
        			this.total = response.data.total;
        		})
        	},

        	generateReport () {
        		axios({
        		url: "/api/generateAuctionExcel",
        		data: {auction_id: this.$route.params.id},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				type: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "report.xlsx");
        		})
        	},

        	generateSellerReport () {
        		axios({
        		url: "/api/generateSellerExcel",
        		data: {auction_id: this.$route.params.id},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				type: 'success',
        				title: 'Report Generated'
        			})
        			//this.seller = response.data;
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "report.xlsx");
        		})
        	},

        	generateBuyerReport () {
        		axios({
        		url: "/api/generateBuyerExcel",
        		data: {auction_id: this.$route.params.id},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				type: 'success',
        				title: 'Report Generated'
        			})
        			//this.seller = response.data;
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "report.xlsx");
        		})
        	}
        }
    }
</script>
